import React from 'react'
import Hero from './Hero/Hero'
import Desc from './Desc/Desc'
import Projects from './Projects/Projects'
import Skills from './Skills/Skills'
import Contact from './Contact/Contact'

const Landing = () => {
    return (
        <div>
            <Hero />
            <div id="about">
                <Desc />
            </div>
            <div id="projects">
                <Projects />
            </div>
            <div id="skills">
                <Skills />
            </div>
            <div id="contact">
                <Contact />
            </div>
        </div>
    )
}

export default Landing